import React, { useEffect, useState, useContext } from "react";
import $ from "jquery";
import { Storage } from "aws-amplify";
import { useDropzone } from "react-dropzone";
import ReactCrop from "react-image-crop";
import toast from "react-hot-toast";
import { Button, Col, Container, Form, Modal, Row } from "react-bootstrap";

import { formatPhoneNumber, emailRegex, getId, accessToken } from "../../Utility/index";
import ChangePasswordModal from "./components/ChangePasswordModal";
import { Context } from "../../Utility/ContextManager";
import { SpinnerLoading } from "../../components/Loadings";
import { fetchSignedUrl, updateTenantFn } from "../../Utility/ApiService";
import envFile from "../../envFile";
import axios from "axios";

export default function MyAccount() {
  const { user, setUser } = useContext(Context);

  const [userInfo, setUserInfo] = useState({
    first_name: "",
    last_name: "",
    email: "",
    phone: "",
  });

  useEffect(() => {
    if (user) {
      setUserInfo({
        first_name: user?.first_name,
        last_name: user?.last_name,
        email: user?.email,
        phone: user?.phone,
      });
    }
  }, [user]);

  const [showSuccessDialog, setShowSuccessDialog] = useState(false);
  const [showPassword, setShowPassword] = useState(false);
  const [loading, setLoading] = useState(false);
  const [viewImage, setViewImage] = useState(undefined);
  const [image, setImage] = useState(undefined);
  const [crop, setCrop] = useState();
  const [selectImageName, setSelectImageName] = useState();
  const [changeEmailModal, setChangeEmailModal] = useState(false);
  const [changedNewEmail, setChangedNewEmail] = useState();
  const [oldEmail, setOldEmail] = useState();
  const [show, setShow] = useState(false);

  useEffect(() => {
    $(".profile-details a.edit-btn").on("click", function (e) {
      e.preventDefault();
      $(this).closest(".card-body").toggleClass("hide-elements");
    });
    $(".profile-details .save-btn .btn").on("click", function () {
      $(this).closest(".card-body").removeClass("hide-elements");
    });
    $(".profile-details .cancel-btn .btn").on("click", function () {
      $(this).closest(".card-body").removeClass("hide-elements");
    });
  }, []);

  useEffect(() => {
    if (!viewImage) {
      setCrop();
    }
  }, [viewImage]);

  const onChange = (text, userInfoKey) => {
    setUserInfo({
      ...userInfo,
      [userInfoKey]: text,
    });
  };

  const updateUserInfo = async (profile_pic) => {
    setLoading(true);

    let obj = {
      id: user.id,
      first_name: userInfo.first_name,
      last_name: userInfo.last_name,
      email: userInfo.email,
      phone: userInfo.phone,
      ...(profile_pic && { profile_picture: profile_pic }),
    };

    await updateTenantFn(obj)
      .then((res) => {
        setUser(res);
        setLoading(false);
        if (profile_pic) fetchProfilePicture(profile_pic);
        showSuccessMessage("You profile information has been updated");
      })
      .catch((error) => {
        setLoading(false);
        console.log(error);
      });
  };

  const showSuccessMessage = (message) => {
    setShowSuccessDialog(message);
    setTimeout(() => {
      setShowSuccessDialog();
    }, 5000);
  };

  const { getRootProps, getInputProps, open } = useDropzone({
    accept: {
      "image/jpeg": [".jpeg", ".jpg", ".png"],
    },
    onDrop: (acceptedFiles) => {
      let image = acceptedFiles[0];

      setSelectImageName(acceptedFiles[0].path);
      setViewImage(URL.createObjectURL(image));
    },
  });

  const imageCrop = (crop) => {
    setCrop(crop);
  };

  const cropImageNow = async () => {
    const canvas = document.createElement("canvas");
    const scaleX = image.naturalWidth / image.width;
    const scaleY = image.naturalHeight / image.height;
    canvas.width = crop.width;
    canvas.height = crop.height;
    const ctx = canvas.getContext("2d");

    const pixelRatio = window.devicePixelRatio;
    canvas.width = crop.width * pixelRatio;
    canvas.height = crop.height * pixelRatio;
    ctx.setTransform(pixelRatio, 0, 0, pixelRatio, 0, 0);
    ctx.imageSmoothingQuality = "high";

    ctx.drawImage(
      image,
      crop.x * scaleX,
      crop.y * scaleY,
      crop.width * scaleX,
      crop.height * scaleY,
      0,
      0,
      crop.width,
      crop.height
    );

    return new Promise((reject, resolve) => {
      canvas.toBlob((blob) => {
        if (!blob) {
          reject(new Error("the image canvas is empty"));
          return;
        }
        blob.name = selectImageName;
        let imageURL;
        window.URL.revokeObjectURL(imageURL);
        imageURL = window.URL.createObjectURL(blob);
        resolve(imageURL);

        addPhotosToS3(blob);
      }, "image1/jpeg");
    });
  };

  const addPhotosToS3 = async (file) => {
    try {
      setLoading(true);
      const name = "tenant_" + getId();
      await Storage.put(`profile_pictures/${name}`, file, {
        level: "public",
      });

      updateUserInfo(name);
      // uploadPropertyUnitDoc(file, name);
      setLoading(false);
    } catch (error) {
      setLoading(false);
      console.log("Error uploading file: ", error);
    }
  };

  const fetchProfilePicture = async (profile_picture) => {
    setLoading(true);
    const pictrue = await fetchSignedUrl(profile_picture, "profile_pictures");
    setUser({ ...user, profile_picture: pictrue });
    setViewImage();
    setLoading(false);
  };

  const handleChangeEmail = async () => {
    try {
      var checkEmailError =
        /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|.(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

      if (!checkEmailError.test(changedNewEmail)) {
        setOldEmail(true);
        return;
      }

      setLoading(true);

      if (changedNewEmail) {
        const res = await accessToken();
        const response = await axios.post(
          `${envFile.PUBLIC_API_LINK}/updateEmailVerfication`,
          {
            user_id: user?.id,
            user_role: "Tenant",
            old_email: user?.email,
            new_email: changedNewEmail,
            cognito_user_id: user?.cognito_user_id,
          },
          {
            headers: {
              Authorization: res.data.access_token,
            },
          }
        );
        if (response?.status === 200) setShow(true);
      }

      setChangeEmailModal(false);
      setLoading(false);
    } catch (error) {
      console.log("error", error);
      setLoading(false);
    }
  };

  return (
    <>
      <div>
        {loading && (
          <div className="loadingSpinner">
            <SpinnerLoading />
          </div>
        )}
        <ChangePasswordModal
          setShowPassword={setShowPassword}
          showPassword={showPassword}
          showSuccessMessage={showSuccessMessage}
        />
        <div>
          {showSuccessDialog && (
            <div className="errors">
              <div className="error success">
                {showSuccessDialog}
                <a
                  href="#"
                  className="close-error"
                  onClick={(e) => {
                    e.preventDefault();
                    setShowSuccessDialog(false);
                  }}
                >
                  <img src={require("../../assets/images/close.svg").default} alt="" />
                </a>
              </div>
            </div>
          )}

          <div>
            {/* START page title */}
            <div className="row">
              <div className="col-xl-5 col-lg-4">
                <div className="page-title">
                  <h2>My Account</h2>
                </div>
              </div>
              <div className="col-xl-7 col-lg-8"></div>
            </div>
            <div className="row">
              <div className="col-12">
                <div className="profile-info d-flex align-items-center">
                  <div className="profile-img me-4">
                    <span className="name" style={{ display: "none" }}></span>
                    {/* profileDummy.png */}
                    {/* {user?.profile_picture && ( */}
                    <img
                      src={
                        user?.profile_picture
                          ? user.profile_picture
                          : require("../../assets/images/profileDummy.png").default
                      }
                      alt=""
                    />
                    {/* )} */}
                    <a href="#" className="edit-btn" data-bs-toggle="modal" data-bs-target="#uploadProfilePhoto">
                      <img src={require("../../assets/images/edit.svg").default} alt="" />
                    </a>
                  </div>
                  <div className="profile">
                    <h3>
                      {user?.first_name} {user?.last_name}
                    </h3>
                    <span>Tenant</span>
                  </div>
                </div>
                {/* END profile info */}
              </div>
            </div>

            <div className="row profile-details">
              <div className="col-xl-6 col-md-8">
                <div className="card">
                  <div className="card-body">
                    <div className="title">
                      <h5>First Name</h5>
                      <a href="#" className="edit-btn">
                        <img src={require("../../assets/images/edit.svg").default} alt="" className="edit" />
                        <img
                          onClick={() => {
                            setUserInfo({
                              ...userInfo,
                              first_name: user?.first_name,
                            });
                          }}
                          src={require("../../assets/images/close.svg").default}
                          alt=""
                          className="cancel"
                        />
                      </a>
                    </div>
                    <div className="visible-field">
                      <img src={require("../../assets/images/user-icon.svg").default} alt="" />
                      {userInfo.first_name}
                    </div>
                    <div className="editable-field d-flex">
                      <div className={"user-field " + (!userInfo?.first_name && "error")}>
                        <input
                          type="text"
                          value={userInfo.first_name}
                          className="icon icon-user form-control"
                          onChange={(e) => onChange(e.target.value, "first_name")}
                        />
                        {!userInfo?.first_name && <p>Please Provide the First Name</p>}
                      </div>
                      <div className="d-flex">
                        <div className="cancel-btn">
                          <button
                            disabled={!userInfo?.last_name ? true : false}
                            onClick={() => {
                              setUserInfo({
                                ...userInfo,
                                first_name: user?.first_name,
                              });
                            }}
                            className="btn btn-primary w-100"
                          >
                            Cancel
                          </button>
                        </div>
                        <div className="save-btn">
                          <button
                            disabled={!userInfo?.first_name ? true : false}
                            onClick={() => updateUserInfo()}
                            type="submit"
                            className="btn btn-primary w-100"
                          >
                            Save
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="card">
                  <div className="card-body">
                    <div className="title">
                      <h5>Last Name</h5>
                      <a href="#" className="edit-btn">
                        <img src={require("../../assets/images/edit.svg").default} alt="" className="edit" />
                        <img
                          onClick={() => {
                            setUserInfo({
                              ...userInfo,
                              last_name: user?.last_name,
                            });
                          }}
                          src={require("../../assets/images/close.svg").default}
                          alt=""
                          className="cancel"
                        />
                      </a>
                    </div>
                    <div className="visible-field">
                      <img src={require("../../assets/images/user-icon.svg").default} alt="" />
                      {userInfo.last_name}
                    </div>
                    <div className="editable-field d-flex">
                      <div className={"user-field " + (!userInfo?.last_name && "error")}>
                        <input
                          type="text"
                          value={userInfo.last_name}
                          className="icon icon-user form-control"
                          onChange={(e) => onChange(e.target.value, "last_name")}
                        />
                        {!userInfo?.last_name && <p>Please Provide the Last Name</p>}
                      </div>
                      <div className="d-flex">
                        <div className="cancel-btn">
                          <button
                            disabled={!userInfo?.last_name ? true : false}
                            onClick={() => {
                              setUserInfo({
                                ...userInfo,
                                last_name: user?.last_name,
                              });
                            }}
                            className="btn btn-primary w-100"
                          >
                            Cancel
                          </button>
                        </div>
                        <div className="save-btn">
                          <button
                            disabled={!userInfo?.last_name ? true : false}
                            onClick={() => updateUserInfo()}
                            type="submit"
                            className="btn btn-primary w-100"
                          >
                            Save
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                {/* END Card */}
                <div className="card">
                  <div className="card-body">
                    <div className="title">
                      <h5>Email</h5>
                      {/* <a href="#">
                      <img
                        onClick={() => {
                          setUserInfo({
                            ...userInfo,
                            email: user?.email,
                          });
                        }}
                        src={require("../../assets/images/close.svg").default}
                        alt=""
                        className="cancel"
                      />
                    </a> */}
                      <div
                        className={`add-btn d-inline-flex justify-content-center align-items-center mb-2 pointer`}
                        onClick={() => setChangeEmailModal(true)}
                      >
                        <strong style={{ fontSize: "14px" }}>Change Email</strong>
                      </div>
                    </div>
                    <div className="visible-field">
                      <img src={require("../../assets/images/email-icon.svg").default} alt="" />
                      {userInfo?.email}
                    </div>
                    <div className="editable-field d-flex">
                      <div
                        className={
                          "user-field " +
                          (!userInfo?.email ? "error" : !emailRegex.test(userInfo?.email) ? "error" : "")
                        }
                      >
                        <input
                          type="email"
                          value={userInfo.email}
                          className="icon icon-mail form-control"
                          onChange={(e) => {
                            onChange(e.target.value, "email");
                          }}
                        />
                        {!userInfo?.email ? (
                          <p>Please Provide an Email</p>
                        ) : !emailRegex.test(userInfo?.email) ? (
                          <p>Please Provide an Valid Email</p>
                        ) : null}
                      </div>
                      <div className="save-btn">
                        <button
                          type="submit"
                          className="btn btn-primary w-100"
                          onClick={() => updateUserInfo()}
                          disabled={!userInfo?.email ? true : !emailRegex.test(userInfo?.email) ? true : false}
                        >
                          Save
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
                {/* END Card */}
                <div className="card">
                  <div className="card-body">
                    <div className="title">
                      <h5>Phone</h5>
                      <a href="#" className="edit-btn">
                        <img src={require("../../assets/images/edit.svg").default} alt="" className="edit" />
                        <img
                          onClick={() => {
                            setUserInfo({
                              ...userInfo,
                              phone: user?.phone,
                            });
                          }}
                          src={require("../../assets/images/close.svg").default}
                          alt=""
                          className="cancel"
                        />
                      </a>
                    </div>
                    <div className="visible-field">
                      <img src={require("../../assets/images/phone-icon.svg").default} alt="" />
                      {formatPhoneNumber(userInfo.phone)}
                    </div>
                    <div className="editable-field d-flex">
                      <div
                        className={
                          "user-field " + (!userInfo.phone ? " error" : userInfo?.phone?.length < 14 ? " error" : "")
                        }
                      >
                        <input
                          maxLength={14}
                          type="email"
                          value={userInfo?.phone}
                          className="icon icon-phone form-control"
                          onChange={(e) => {
                            let formattedText = formatPhoneNumber(e.target.value);
                            onChange(formattedText, "phone");
                          }}
                        />
                        {!userInfo?.phone ? (
                          <p>Please Provide Phone Number</p>
                        ) : userInfo?.phone?.length < 14 ? (
                          <p>Please Provide a Phone Number</p>
                        ) : null}
                      </div>
                      <div className="d-flex">
                        <div className="cancel-btn">
                          <button
                            disabled={!userInfo?.phone ? true : false}
                            onClick={() => {
                              setUserInfo({
                                ...userInfo,
                                phone: user?.phone,
                              });
                            }}
                            className="btn btn-primary w-100"
                          >
                            Cancel
                          </button>
                        </div>
                        <div className="save-btn">
                          <button
                            disabled={userInfo?.phone?.length < 14 ? true : false}
                            type="submit"
                            className="btn btn-primary w-100"
                            onClick={() => updateUserInfo()}
                          >
                            Save
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>{" "}
                {/* END Card */}
                <Button
                  className="resetBtn"
                  // variant='primary'

                  onClick={() => setShowPassword(true)}
                >
                  Change Password
                  <img
                    className="right-arrow"
                    width={50}
                    height={50}
                    src={require("../../assets/images/arrow-right.svg").default}
                    alt=""
                  />
                </Button>
                {/* END Card */}
              </div>
            </div>
          </div>

          {/* END main content */}
        </div>
        {/* END layout-wrapper */}
        {/* Upload Profile Photo Modal */}
        <div
          className="modal fade modal-style-1"
          id="uploadProfilePhoto"
          tabIndex={-1}
          aria-hidden="true"
          data-bs-backdrop="static"
        >
          <div className="modal-dialog">
            <div className="modal-content">
              <div className="modal-header">
                <h4 className="modal-title">Upload profile photo</h4>
              </div>
              <div className="modal-body" style={{ minWidth: "400px", textAlign: "center" }}>
                {viewImage ? (
                  <ReactCrop crop={crop} ruleOfThirds aspect={1 / 1} onChange={imageCrop}>
                    <img
                      className="selectProfilePic"
                      src={viewImage}
                      onLoad={(e) => {
                        setImage(e.currentTarget);
                      }}
                      alt={"Profile Pic"}
                    />
                  </ReactCrop>
                ) : (
                  <div className="dropDrag" {...getRootProps()}>
                    <input {...getInputProps()} />
                    <p className="mb-3">JPG, PNG, or PDF, smaller than 10 MB</p>
                    <p>Drag and drop your image here</p>
                    <p>or choose file</p>
                  </div>
                )}

                <div className="row modal-btns mt-2">
                  <div className="col-6">
                    <button
                      type="button"
                      className="btn btn-warning w-100"
                      data-bs-dismiss="modal"
                      onClick={() => {
                        setViewImage();
                      }}
                    >
                      Cancel
                    </button>
                  </div>
                  <div className="col-6">
                    <button
                      // {...getInputProps()}
                      onClick={() => {
                        if (viewImage) {
                          if (!crop) {
                            toast.error("Image size is too large");
                            return;
                          }
                          cropImageNow();
                        } else {
                          open();
                        }
                      }}
                      data-bs-dismiss={viewImage && "modal"}
                      disabled={!viewImage ? false : !crop ? true : false}
                      type="button"
                      className="btn btn-primary btn-send sendBtn"
                      // onClick={onHandleSend}
                    >
                      {viewImage ? "Save" : "Choose File"}
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <Modal
        show={changeEmailModal}
        onHide={() => {
          setChangeEmailModal(false);
          setChangedNewEmail("");
        }}
        centered
        className="modal-style-1 w-100 pd-md"
      >
        <Modal.Header>
          <Modal.Title as="h3" className="w-100 text-center">
            Change Email Address
          </Modal.Title>
        </Modal.Header>
        <Modal.Body className="text-center mb-3">
          <Row className="text-start">
            <Col>
              <Form.Group className={`check ${oldEmail ? "is-invalid" : ""} `}>
                <Form.Label>Email Address</Form.Label>
                <Form.Control
                  placeholder="Please Enter Email"
                  value={changedNewEmail}
                  onChange={(e) => {
                    setChangedNewEmail(e.target.value);
                    if (e.target.value === user?.email) {
                      setOldEmail(true);
                    } else {
                      setOldEmail(false);
                    }
                  }}
                />
                <Form.Text className="ms-1" style={{ color: "#DC3545" }}>
                  {oldEmail && "Please enter a valid Email"}
                </Form.Text>
              </Form.Group>
              {/* <FormInput name="new_email" placeholder="Please Enter Email" label="Email" /> */}
            </Col>
          </Row>
        </Modal.Body>
        <Modal.Footer>
          <Container className="m-0">
            <Row>
              <Col xs={6}>
                <Button
                  className="btn-reset w-100"
                  onClick={() => {
                    setChangeEmailModal(false);
                    setChangedNewEmail("");
                  }}
                >
                  Cancel
                </Button>
              </Col>
              <Col xs={6}>
                <Button
                  type="submit"
                  className=" w-100"
                  disabled={oldEmail || !changedNewEmail}
                  onClick={handleChangeEmail}
                >
                  Save
                </Button>
              </Col>
            </Row>
          </Container>
        </Modal.Footer>
      </Modal>
      <Modal show={show} onHide={() => setShow(false)} className="modal-style-1 w-100 pd-md" centered>
        <Modal.Header>
          <Modal.Title as="h3" className="w-100 text-center">
            Verification Email Sent
          </Modal.Title>
        </Modal.Header>
        <Modal.Body className="text-center mb-3">A verification email was sent to the new email address</Modal.Body>
        <Modal.Footer>
          <Button className="w-100" onClick={() => setShow(false)}>
            OK
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
}
